import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import { Tabs } from '@liminal/web-ui/primitives/Tabs';

// Overview first: it answers "is anything wrong, and is there money to pay
// back?" before anyone goes looking at partners or budgets.
const subTabs = [
  { label: 'Overview', path: '/rewards/overview' },
  { label: 'Payments', path: '/rewards/payments' },
  { label: 'Partners', path: '/rewards/partners' },
  { label: 'Budgets', path: '/rewards/budgets' },
  { label: 'How it works', path: '/rewards/how-it-works' },
];

/**
 * Partner Rewards: customers paying a partner by Pix choose to earn LIL, or to
 * pay with LIL and get the money back from the treasury, within a budget.
 */
export function RewardsPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const active = subTabs.find(
    (tab) => location.pathname === tab.path || location.pathname.startsWith(tab.path + '/'),
  );

  return (
    <Stack spacing={3}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={(active ?? subTabs[0]).path}
          onChange={navigate}
          aria-label="Rewards sections"
          items={subTabs.map((tab) => ({ value: tab.path, label: tab.label }))}
        />
      </Box>
      <Outlet />
    </Stack>
  );
}
